module.exports = __webpack_public_path__ + "static/img/CITF.a3cf4e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/about/images/CITF.jpg
// module id = /bFI
// module chunks = 21